export default {
  scorecard: {
    title: 'บัตรคะแนน',
    content: 'เนื้อหา',
    award: 'รางวัล ESG',
  },
  list_table_filter: {
    table_buyer_company_name: 'บริษัทผู้ซื้อ',
    table_question_group_name: 'แบบสอบถาม',
    table_status: 'สถานะ',
    table_issue_at: 'วันที่ออก',
    table_sustaina_rate: 'การจัดอันดับ ESG',
    table_esg_score: 'คะแนน ESG',
    table_operation: 'การดำเนินการ',
    displayed_items_number: 'แสดง {start}〜{end} / {total} บริษัท',
    displayed_items_number_empty: 'แสดง 0 / 0 บริษัท',
    no_data_display: 'ไม่มีข้อมูล',
    csv_modal_title: 'โปรดเลือกรายการที่จะส่งออกในรูปแบบ CSV',
    csv_modal_answer_status_title: 'สถานะคำตอบ',
    csv_modal_answer_status_text: 'ส่งออกรายการสถานะคำตอบของซัพพลายเออร์',
    csv_modal_answer_title: 'คำตอบ (1 ไฟล์ต่อ 500 บริษัท)',
    csv_modal_answer_title_by_individual_company: 'คำตอบ (1 ไฟล์ต่อบริษัท)',
    csv_modal_answer_text: 'คำตอบของซัพพลายเออร์จะแสดงผลเป็น 1 ไฟล์ต่อ 500 บริษัท',
    csv_modal_answer_text_by_individual_company: 'คำตอบของซัพพลายเออร์จะแสดงผลเป็น 1 ไฟล์ต่อ 1 บริษัท',
    csv_modal_score_title: 'คะแนน',
    csv_modal_score_text: 'ส่งออกอันดับและคะแนนของซัพพลายเออร์',
    csv_modal_answer_heading: 'ส่วนหัว',
    csv_modal_answer_heading_supplier: 'ซัพพลายเออร์',
    csv_modal_answer_heading_question: 'คำถาม',
    csv_modal_answer_additional: 'รายการเพิ่มเติม',
    csv_modal_answer_additional_note: 'หมายเหตุ',
    csv_modal_answer_additional_file: 'ชื่อไฟล์แนบ',
    csv_modal_cautionary_note_title: 'ประกาศ',
    csv_modal_cautionary_note_content: '・ไฟล์เอาต์พุตประกอบด้วย "สถานะคำตอบ" "คำตอบ" และ "คะแนน" สำหรับ {questionGroupName}\n・สำหรับ "สถานะคำตอบ" จะรวมบริษัทที่ลงทะเบียนทั้งหมด ไม่ว่าสถานะคำตอบในแบบสำรวจจะเป็นอย่างไรก็ตาม\n・สำหรับ "คำตอบ" และ "คะแนน" บริษัทที่มีสถานะคำตอบ "อยู่ระหว่างดำเนินการ" จะไม่รวมอยู่ในไฟล์ผลลัพธ์\n・จำนวนสูงสุดของบริษัทที่สามารถแสดงในไฟล์ CSV เดียวสำหรับ "คำตอบ" และ "คะแนน" ได้คือ 1,000 บริษัท\n・ไฟล์ CSV จะถูกส่งไปยังที่อยู่อีเมลของบัญชีที่เข้าสู่ระบบในปัจจุบัน',
    csv_modal_sent_mail_section_one: 'คำขอส่งออก CSV ของคุณได้รับการยอมรับแล้ว',
    csv_modal_sent_mail_section_two: 'โปรดรอสักครู่จนกว่าอีเมลพร้อม URL สำหรับดาวน์โหลด CSV จะถูกส่งไปยังที่อยู่อีเมลของคุณ',
    csv_modal_sent_mail_section_three: 'หากคุณไม่ได้รับอีเมลภายใน 30 นาที โปรดลองอีกครั้ง',
  },
  overall_score_section: {
    card_title: 'เนื้อหาของแบบสำรวจ',
    score: 'คะแนน',
    esg_score: 'คะแนน ESG',
    esg_rating: 'การจัดอันดับ ESG',
    esg_score_tip: 'คะแนน ESG เป็นการประเมินกิจกรรม ESG ของบริษัทของคุณ \nซึ่งคำนวณจากคำตอบของคุณต่อแบบสำรวจ ASUENE ESG',
    esg_rating_tip: 'การจัดอันดับ ESG คือการประเมินระดับกิจกรรม ESG ของบริษัทของคุณโดยสมบูรณ์ โดยจัดหมวดหมู่ตามระดับเจ็ดจุดตั้งแต่ AAA ถึง CCC โดยอิงจากคะแนน ESG ของคุณ',
    evaluator_advice_title: 'ความคิดเห็นเกี่ยวกับการประเมิน',
    list_header_buyer_company_name: 'บริษัทผู้ซื้อ',
    list_header_supplier_company_name: 'ซัพพลายเออร์',
    list_header_question: '@:common.upload.title',
    list_header_create_at: 'วันที่ออก',
    list_header_deadline: 'ระยะเวลาที่ใช้ได้',
    list_header_industry: 'อุตสาหกรรม',
    list_header_company_scale: 'จำนวนพนักงาน',
    download_csv: 'ส่งออก CSV',
    download_pdf: 'ส่งออก PDF',
    csv_title_for_buyer: 'ตอบแบบสอบถาม ASUENE ESG',
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'ดาวน์โหลดคำตอบในรูปแบบ csv',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'ดาวน์โหลดคำตอบในรูปแบบ pdf',
    scorecard_pdf: 'บัตรคะแนน(PDF)',
    download_scorecard_pdf_description: 'ดาวน์โหลดคะแนนในรูปแบบ pdf',
    feedback: 'ข้อเสนอแนะการประเมินผล',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'เอกสารจะถูกดาวน์โหลดเป็น PDF',
    award_medal_svg: 'รางวัล ESG(SVG)',
    download_award_medal_svg_description: 'ดาวน์โหลดเป็นรูปภาพ SVG',
    award_medal_png: 'รางวัล ESG(PNG)',
    download_award_medal_png_description: 'ดาวน์โหลดเป็นรูปภาพ PNG',
    pdf_modal_sent_mail_section_one: 'คำขอส่งออก PDF ของคุณได้รับการยอมรับแล้ว',
    pdf_modal_sent_mail_section_two: 'โปรดรอสักครู่จนกว่าอีเมลพร้อม URL สำหรับดาวน์โหลด PDF จะถูกส่งไปยังที่อยู่อีเมลของคุณ',
    pdf_modal_sent_mail_section_three: 'หากคุณไม่ได้รับอีเมลภายใน 30 นาที โปรดลองอีกครั้ง',
  },
  category_score_section: {
    card_title: 'คะแนนตามหมวดหมู่',
    tip: 'คะแนนหมวดหมู่คือคะแนนสำหรับหมวดหมู่ด้านสิ่งแวดล้อม สังคม และธรรมาภิบาลของบริษัทของคุณ การถ่วงน้ำหนักของคำถามในแต่ละหมวดหมู่จะแตกต่างกันไปตามบริษัท',
    policy: 'นโยบาย',
    action: 'การดำเนินการ',
    result: 'ผลลัพธ์',
  },
  score_by_category_compared_section: {
    card_title: 'การเปรียบเทียบคะแนนตามหมวดหมู่',
    get_score_by_category: 'คะแนนหมวดหมู่ของบริษัทของคุณ',
    esg_evaluated_all_companies_average: 'Aทุกบริษัทที่ได้รับการประเมินโดย ASUENE ESG',
    tip: 'นี่คือคะแนนเฉลี่ยของบริษัทที่ตอบแบบสำรวจเดียวกัน',
  },
  strengths_advice_section: {
    card_title: 'ความแข็งแกร่ง คำแนะนำ',
    strong_point: 'ความแข็งแกร่ง',
    advice: 'จุดปรับปรุง',
    policies: 'นโยบาย',
    action: 'การดำเนินการ',
    result: 'ผลลัพธ์',
    no_results_for_this_category: 'ไม่มีผลลัพธ์สำหรับหมวดหมู่นี้',
    risk: 'ความเสี่ยง',
    indicator: 'ตัวบ่งชี้',
    content: 'เนื้อหา',
    operation: 'การดำเนินการ',
  },
  preview: {
    go_back_to_scorecard: 'ย้อนกลับไปที่สกอร์การ์ด',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'สรุปคะแนนโดยรวม',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'คะแนนเฉลี่ย',
    category_card_score_no_score: 'ไม่สามารถใช้ได้',
    category_card_score_earned_score: 'คะแนนของคุณ',
    category_card_details_list_title: 'ความคิดเห็นเกี่ยวกับการประเมิน',
    category_card_details_no_score_tip: 'หมวดหมู่นี้ไม่รวมอยู่ในการประเมิน',
    category_card_score_average_score: 'คะแนนเฉลี่ยของทุกบริษัท',
    category_card_details_title: 'สรุปคะแนนหมวดหมู่',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: 'รายการนี้ไม่เกี่ยวข้อง เนื่องจากการสำรวจจะได้รับการประเมินตามตรรกะของผู้ซื้อ',
    buyer_evaluate_tip: 'รายการนี้จะได้รับการประเมินตามตรรกะของผู้ซื้อ ไม่ได้รับการประเมินตามหลักตรรกะการให้คะแนนของ Asuene ESG',
    answer_rejection_notification: 'คุณได้รับคำขอถอนเงินใหม่',
    answer_rejection_modal_title: 'ส่งกลับการยื่น',
    answer_rejection_modal_text: 'ส่งกลับข้อคิดเห็น',
    answer_rejection_modal_content: 'คำตอบของ {companyName} จะถูกส่งกลับ \nโปรดเขียนความคิดเห็นพร้อมเหตุผลของการส่งกลับ',
    answer_rejection_dialog_content: 'คำตอบของ {companyName} ถูกส่งกลับแล้ว',
    answer_rejection_button_title: 'ส่งกลับ',
  },
}
